import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { auth } from '../lib/api';
import { useAuthStore } from '../store/useStore';
import { trackEvent } from '../lib/analytics';
import AuthFrame from '../components/AuthFrame';

export default function Login() {
  const [usernameOrEmail, setUsernameOrEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const setAuth = useAuthStore((state) => state.setAuth);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);

    try {
      const { user, token } = await auth.login({ usernameOrEmail, password });
      setAuth(user, token);
      trackEvent('login');
      navigate('/read');
    } catch (error) {
      toast.error(error instanceof Error ? error.message : 'Login failed');
    } finally {
      setLoading(false);
    }
  }

  return (
    <AuthFrame kicker="Sign in" title="Welcome back.">
      <form onSubmit={handleSubmit} className="space-y-5">
        <div>
          <label htmlFor="usernameOrEmail" className="label">Username or email</label>
          <input
            id="usernameOrEmail"
            type="text"
            required
            autoComplete="username"
            value={usernameOrEmail}
            onChange={(e) => setUsernameOrEmail(e.target.value)}
            className="field"
          />
        </div>

        <div>
          <div className="flex items-baseline justify-between">
            <label htmlFor="password" className="label">Password</label>
            <Link to="/forgot-password" className="kicker hover:text-ink">
              Forgot?
            </Link>
          </div>
          <input
            id="password"
            type="password"
            required
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="field"
          />
        </div>

        <button type="submit" disabled={loading} className="btn btn-accent w-full">
          {loading ? 'Signing in…' : 'Sign in'}
        </button>
      </form>

      <p className="mt-6 text-sm text-ink-muted">
        No account?{' '}
        <Link to="/register" className="text-ink underline underline-offset-2 hover:text-accent-600">
          Register with an invite code
        </Link>
      </p>
    </AuthFrame>
  );
}
